import * as Yup from 'yup';

const AssetNameSchema = Yup.object().shape({
  site: Yup.string().required('Required'),
  assetType: Yup.string().required('Required'),
  clientCode: Yup.string().required('Required'),
  amountReserving: Yup.number().min(1, 'No assets? Do some work!'),
  reasonForReservation: Yup.string().required('Required'),
  uid: Yup.string().required('Required, please generate a UID'),
})

export default AssetNameSchema
